import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzModalDeleteModalComponent } from './delete-modal/delete-modal.component';
import { NzModalModule, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { UIModule } from '../../ui/ui.module';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { CommonModule } from '@angular/common';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzShareModule } from '../../nz/nz-share.module';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzModalHungUp } from './modal-hungup/modal-hung-up.component';
import { NzTimeSessionModalComponent } from './time-session-modal/time-session-modal.component';

@NgModule({
  declarations: [
    NzModalDeleteModalComponent,
    NzModalHungUp,
    NzTimeSessionModalComponent
  ],
  imports: [
      ReactiveFormsModule,
      FormsModule,
      NzModalModule,
      NzButtonModule,
      UIModule,
      NzSwitchModule,
      CommonModule,
      NzCheckboxModule,
      NzShareModule,
      NzDropDownModule,
    ],
  exports: [
    NzModalDeleteModalComponent,
    NzModalHungUp,
    NzTimeSessionModalComponent
  ],
  providers: [
    NzModalService
  ]
})
export class ModalsModule {}
